module.exports = __webpack_public_path__ + "img/profile-human-b.567d05ea.png";